import { DestroyRef, inject, Injectable } from "@angular/core";
import { Events } from "@app/core/models/event-map";
import { PublishSubscribeService } from "@app/core/services/publish-subscribe.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { PortalApiService } from "../portal-api.service";
import { UserService } from "../User.Service";
import { NewVersionInfoComponent } from "@app/core/components/new-version-info/new-version-info.component";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Injectable({
    providedIn: 'root'
})
export class NotificationsService {

    readonly #destroyRef = inject(DestroyRef)

    constructor(
        private userInternalService: UserService,
        private publishSubscribeService: PublishSubscribeService,
        private toastr: ToastrService,
        private modalService: BsModalService,
        private portalApiService: PortalApiService
    ) {
        // Listen for event when we received a push message from CustPortal frontend
        this.publishSubscribeService.on(Events.CustPortalHubService.CHECK_NOTIFICATIONS_RECEIVED)
            .subscribe({
                next: (event: any) => {
                    this.handleEvent_CustPortalHubService_CHECK_NOTIFICATIONS_RECEIVED(event)
                }
            })
    }

    handleEvent_CustPortalHubService_CHECK_NOTIFICATIONS_RECEIVED(event: any) {
        // Get received notification
        const portalUserNotifications = event.notifications;

        // Check notification
        this.checkNotifications(portalUserNotifications);
    }

    checkPortalNotification_LatestNewVersion() {

        this.portalApiService.getNotificationLatestNewVersion()
            .pipe(takeUntilDestroyed(this.#destroyRef)).subscribe({
                next: (response) => {
                    const showNotification = false;

                    if (response != undefined && showNotification) {
                        this.openModalNewVersionInfo(response.ID);
                    }
                },
                error: (error) => console.error('checkPortalNotification_LatestNewVersion', JSON.stringify(error))
            })
    }

    openModalNewVersionInfo(notificationId) {
        const initialState: object = { notificationId: notificationId }

        this.modalService.show(NewVersionInfoComponent, { initialState })
    }

    validateNotificationValidTo = (validTo) => {
        let isValid = false;

        if (validTo != undefined) {
            const dateNow = new Date();
            const dateMin = new Date(-2208988800000); //Ax UtcDateTime.minValue is 1900-01-01 00:00:00

            const validTo_Time = validTo.getTime();
            const dateMin_Time = dateMin.getTime();
            const dateNow_Time = dateNow.getTime();

            isValid = validTo_Time == dateMin_Time || validTo_Time >= dateNow_Time;
        }

        return isValid;
    }

    checkNotifications(portalUserNotifications) {

        let lastSeenNotificationId = 0;
        const axUserId = this.userInternalService.getAxUserId();

        this.portalApiService.getNotifications()
            .pipe(takeUntilDestroyed(this.#destroyRef)).subscribe({
                next: (response) => {
                    for (let i = 0; i < response.length; i++) {
                        const notification = response[i];
                        lastSeenNotificationId = notification.ID > lastSeenNotificationId ? notification.ID : lastSeenNotificationId;
                        this.postNotification(notification, axUserId);
                    }

                    if (lastSeenNotificationId > 0) {
                        this.axPortal_SetLastSeenNotification(lastSeenNotificationId);
                    }
                }
            })
    }

    postNotification = (notification, axUserId) => {
        if (notification != undefined) {
            const publishedDate = new Date(notification.PUBLISHDATETIME).toLocaleDateString();
            const publishedTime = new Date(notification.PUBLISHDATETIME).toLocaleTimeString();
            const subject = notification.SUBJECT;
            let message = notification.MESSAGE;
            const publishedByMessage = `${publishedDate} ${publishedTime} - ${notification.USERFULLNAME} - ${notification.COMPANY}`;

            if (message != undefined) {
                message = message.replace(/(?:\r\n|\r|\n)/g, '<br />');
            }

            var htmlSource = '';

            switch (notification.TYPE) {
                case 0: //Message
                    // Embed HTML within your message.....
                    htmlSource = '<html><body><b>' + subject + '</b><br /><small><small><em>' + publishedByMessage + '</em></small></small><p>' + message + '</p></body></html>';
                    this.toastr.show(htmlSource, '', { enableHtml: true, timeOut: 5000, positionClass: 'toast-bottom-left', toastClass: 'ngx-toastr' })
                    break;
                case 1: //NewVersion
                    // NEW VERSION AVAILABLE NOTIFICATION IS NOW HANDLED BY APP-CACHE IN doOnRouteChange()
                    break;
                case 2: //Warning
                    var closeLink = '<a ng-><span>Stäng&nbsp;&nbsp<i class="fal fa-times-circle fa-lg" title="Stäng"></i></span></a>'
                    htmlSource = '<html><body><b>' + subject + '</b><br /><small><small><em>' + publishedByMessage + '</em></small></small><p>' + message + '</p>' + closeLink + '</body></html>';
                    this.toastr.show(htmlSource, '', { enableHtml: true, positionClass: 'toast-bottom-left', toastClass: 'ngx-toastr', timeOut: 0, extendedTimeOut: 0, closeButton: true, tapToDismiss: false })
                    break;
                case 3: //Intra customer message
                    // Embed HTML within your message.....
                    htmlSource = '<html><body><b>' + subject + '</b><br /><small><small><em>' + publishedByMessage + '</em></small></small><p>' + message + '</p></body></html>';

                    // Dont show messages generated by logged in user
                    if (notification.PUBLISHEDBYUSERID != axUserId) {
                        this.toastr.show(htmlSource, '', { enableHtml: true, timeOut: 5000, positionClass: 'toast-bottom-left', toastClass: 'ngx-toastr' })
                    }
                    break;
                default:
                    break;
            }
        }
    }

    axPortal_SetLastSeenNotification = (lastSeenNotificationId) => {
        this.portalApiService.setLastSeenNotification(lastSeenNotificationId)
            .subscribe({
                error: (error) => console.error('axPortal_SetLastSeenNotification', JSON.stringify(error))
            })
    }

    axPortal_SetLastSeenNewVersion = (notificationId) => {

        this.portalApiService.setLastSeenNewVersion(notificationId)
        .subscribe({
            error: (error) => console.error('axPortal_SetLastSeenNewVersion', JSON.stringify(error))
        })
    }
}
